// extracted by mini-css-extract-plugin
export default {"content":"qJlCL","code":"NALw8","title":"iKZgM"};